module.exports = __webpack_public_path__ + "static/img/s1.93491b4d.png";